module.exports = __webpack_public_path__ + "static/media/cloud-upload.95de97b6.svg";